import { colorToRGBA, getColorAtPixel } from 'q-floodfill';
import EditorColors from '../constants/EditorColors';
import ICoordinates from '../types/ICoordinates';
import colorsMatch from './colorsMatch';

const fillCanvas = (
  canvas: HTMLCanvasElement,
  coordinates: ICoordinates[],
  color: EditorColors,
) => {
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const { width, height } = canvas;
  const imgData = ctx.getImageData(0, 0, width, height);
  let filled = false;
  const { lineWidth } = ctx;
  ctx.lineWidth = 8;
  coordinates.forEach(({ x, y }) => {
    if (!colorsMatch(getColorAtPixel(imgData, x, y), colorToRGBA(color))) {
      filled = true;
      ctx.beginPath();
      ctx.moveTo(x, y);
      ctx.lineTo(x === canvas.width - 1 ? x - 1 : x + 1, y === canvas.height - 1 ? y - 1 : y + 1);
      ctx.stroke();
    }
  });
  ctx.lineWidth = lineWidth;
  return filled;
};

export default fillCanvas;
